
$(document).ready(function () {
  if (window.screen.height == 720) {
    $("#my-dialog").css("margin-top", "10px");
  }
  formSubmit();
});
function formSubmit() {
  $(".addr-form").submit(function (event) {
    event.preventDefault(); //this will prevent the default submit
    var formData = $(this).serializeArray();
    var modalHeight = "630px";
    $.ajax({
      url: "/register/address/verify",
      type: "POST",
      data: formData,
      success: function (response) {
          var createResponse = JSON.parse(response);
          var redirectUrl = createResponse.redirect_url;
          var iframe =
              '<iframe style="width: 100%; height: ' +
              modalHeight +
              ';" frameborder="0" src="' +
              redirectUrl +
              '" onload="addCloseButton(this)" class="eidMeIframe"></iframe>';

          $("#sso-auth-modal-body").append(iframe);

          // Display Bootstrap 5 modal
          const modalElement = document.getElementById("sso-auth-modal");

          const modal = new bootstrap.Modal(modalElement, {
              backdrop: "static",
              keyboard: false,
          });

          modal.show();
      },
    error: function (xhr, status, error) {
        if (xhr.status === 419) {
          document.location.reload(true);
        }
      },
    });
  });
}

window.addCloseButton = function () {
    $("#sso-auth-modal-body").append(
        '<button type="button" class="close close-btn" id="close-auth-modal" ' +
        'aria-label="Close">' +
        '<span aria-hidden="true">' +
        '<img src="/img/modal-close.png" alt="Close">' +
        '</span>' +
        '</button>'
    );

    $("#close-auth-modal").click(function () {
        const modalElement = document.getElementById("sso-auth-modal");
        const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
        modal.hide();
        document.location.reload(true);
    });

    return true;
};

